export const observableSymbol =
  (typeof Symbol !== 'undefined' && Symbol.observable) || '@@observable'
